














































































































































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import ProductToggleSection from '@/web/components/products/ProductToggleSection.vue';
import ProductEditSection from '@/web/components/products/ProductEditSection.vue';
import HMAvailabilitySchedule from '@/web/components/common/HMAvailabilitySchedule.vue';
import { parseDuration } from '@/core/utils/products';
import HMTextInput from '@/web/components/common/HMTextInput.vue';

export default Vue.extend({
  name: 'ProductPrivateSessions',
  components: {
    HMTextInput,
    HMAvailabilitySchedule,
    ProductToggleSection,
    ProductEditSection,
  },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
      acuity: 'setting/acuity',
      googleCalendars: 'setting/googleCalendars',
      timezone: 'user/timezone',
    }),
    hasGoogleCalendars() {
      return this.googleCalendars?.length > 0;
    },
    isPrivateSpaceProduct() {
      return this.productForm?.product_type === 'private_space';
    },
    acuityCalendar: {
      get(): boolean {
        return this.getAcuityCalendarName(this.productForm.acuity_calendar_id);
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          acuity_calendar_id: value,
          acuity_owner_id: this.acuity.acuity_owner_id,
          acuity_form_id: this.acuity.acuity_form_id,
        });
      },
    },
    acuityAppointmentType: {
      get(): boolean {
        return this.getAcuityAppointmentTypeName(
          this.productForm.acuity_appointment_type_id
        );
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          acuity_appointment_type_id: value,
          acuity_owner_id: this.acuity.acuity_owner_id,
          acuity_form_id: this.acuity.acuity_form_id,
        });
      },
    },
    hasPrivateSessions: {
      get(): boolean {
        return this.productForm ? this.productForm.has_private_sessions : false;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductFormPrivateSessions', value);
      },
    },
    numberOfIncludedSessions: {
      get(): number {
        return this.productForm
          ? this.productForm.number_of_included_sessions
          : 0;
      },
      set(value: number) {
        this.$store.dispatch('product/setProductForm', {
          number_of_included_sessions: value,
        });
      },
    },
    calendlyEnabled: {
      get(): boolean {
        return this.productForm.calendly_enabled;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductFormCalendly', value);
      },
    },
    acuityEnabled: {
      get(): boolean {
        return this.productForm.acuity_enabled;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductFormAcuity', value);
      },
    },
    calendlyUrl: {
      get(): string {
        return this.productForm.calendly_url;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          calendly_url: value,
        });
      },
    },
  },
  data() {
    return {
      googleCalendarConnections: [],
      durations: [
        {
          label: 'None',
          code: 0,
        },
        {
          label: '15min',
          code: 15,
        },
        {
          label: '30min',
          code: 30,
        },
        {
          label: '45min',
          code: 45,
        },
        {
          label: '1h',
          code: 60,
        },
        {
          label: '1h15min',
          code: 75,
        },
        {
          label: '1h30min',
          code: 90,
        },
        {
          label: '1h45min',
          code: 105,
        },
        {
          label: '2h',
          code: 120,
        },
      ],
    };
  },
  methods: {
    getAcuityCalendarName(calendarId) {
      return this.acuity?.acuity_calendars?.find(obj => {
        return obj.id == calendarId;
      });
    },
    getAcuityAppointmentTypeName(appointmentTypeId) {
      return this.acuity?.acuity_appointment_types?.find(obj => {
        return obj.id == appointmentTypeId;
      });
    },
    privateSessionDurationOptionCreated(option) {
      try {
        const duration = parseDuration(option.label);
        option.code = duration;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    this.$store.dispatch('setting/getAcuityInfo');
    this.$store.dispatch('setting/getGoogleCalendarConnections');
  },
});
